(function() {
	'use strict';

	angular.module('quantixApp').controller('CompanyLevelAlert',
			CompanyLevelAlert);

	CompanyLevelAlert.$inject = [ '$scope', '$stateParams', '$filter',
			'$rootScope', '$timeout', 'companyData', '$uibModalInstance',
			'CompanyIndAlertService', 'AlertService', 'parentAccess',
			'controllerModule', '$window', 'isSelectAll', 'GenericService' ];

	function CompanyLevelAlert($scope, $stateParams, $filter, $rootScope,
			$timeout, companyData, $uibModalInstance, CompanyIndAlertService,
			AlertService, parentAccess, controllerModule, $window, isSelectAll,
			GenericService) {
		$scope.isSelectAll = isSelectAll;

		$scope.flagRatingMovementStatus = false;
		$scope.flagAllAlerttStatus = false;
		$scope.flagCRRAlerttStatus = false;
		$scope.flagSFAlerttStatus = false;
		$scope.errorCompInfo = false;
		var sectionaccess = {};
		GenericService.getUserSectionAccessData().then(function(result){
			sectionaccess=result;
			if (sectionaccess["Company Profile-Landing.Rating Movement Alert"] != 'Y' && sectionaccess["Portfolio View.Portfolio Level Alert"] != 'Y' ) {
				$scope.flagRatingMovementStatus = true;
				$scope.flagSFAlerttStatus=true;
			
				$scope.errorCompInfo = true;
				$scope.errorMessageCompInfo = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
	
			}
	
			if (sectionaccess["Company Profile-Landing.All Alerts (under company)"] != 'Y' && sectionaccess["Portfolio View.Linking / Sharing"] != "Y" ) {
				$scope.flagAllAlerttStatus = true;
				$scope.errorCompInfo = true;
				$scope.errorMessageCompInfo = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
	
			}
			if (sectionaccess["Company Profile-Landing.CRR Availability"] != 'Y' && sectionaccess["Portfolio View.Portfolio Level Alert"] != 'Y' && sectionaccess["Portfolio View.Linking / Sharing"] != "Y") {
				$scope.flagCRRAlerttStatus = true;
				$scope.errorCompInfo = true;
				$scope.errorMessageCompInfo = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
	
			}
			
			if (sectionaccess["RATING ALERT.ROLE_RATING_ALERT"] == 'Y') {
				$scope.flagCRRAlerttStatus = true;
				$scope.flagAllAlerttStatus = true;
				$scope.flagSFAlerttStatus=true;
				$scope.flagRatingMovementStatus = false;
				$scope.errorCompInfo = true;
				$scope.errorMessageCompInfo = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
	
			}
			
			
			
		});

		$scope.getCompanyAlertDetails = function() {

			var calertdata = {
				companyCode : companyData.companyCode,
				isCompanyLevel : companyData.isCompanyLevel,
				industryId : companyData.industryId,
				isIndustryLevel : companyData.isIndustryLevel,
				portFolioId : companyData.portFolioId,
				isPortfolioLevel : companyData.isPortfolioLevel
			};
			
			
			CompanyIndAlertService.getCompanyAlertDetails(calertdata).then(
					function(data) {
						if (data.length != 0) {
							$scope.compAlertData = data[0];

							if($scope.flagSFAlerttStatus){
								$scope.compAlertData.isSfAvailable="N";
							}
						} else {
							$uibModalInstance.dismiss('cancel');
						}

					}, function(errordata) {
					});

		}

		$scope.isRatingMovementFunction = function() {

			if ($scope.compAlertData.isRatingMovementCheck == 'N') {
				$scope.compAlertData.isRatingMovOutlook = 'N';
				$scope.compAlertData.isRatingMovAllRatingActionisCheck = 'N';
				$scope.compAlertData.isRatingMovementAllRatingAction = 'NA';
			} else if ($scope.compAlertData.isRatingMovementCheck == 'Y') {
				$scope.compAlertData.isRatingMovOutlook = 'N';
				$scope.compAlertData.isRatingMovAllRatingActionisCheck = 'Y';
				$scope.compAlertData.isRatingMovementAllRatingAction = 'A';

			}
		}

		$scope.doInnerRatingMovementCheck = function() {

			if ($scope.compAlertData.isRatingMovAllRatingActionisCheck == 'Y'
					|| $scope.compAlertData.isRatingMovOutlook == 'Y') {
				$scope.compAlertData.isRatingMovementCheck = 'Y';
				if ($scope.compAlertData.isRatingMovAllRatingActionisCheck == 'Y'
						&& $scope.compAlertData.isRatingMovementAllRatingAction == 'NA') {
					$scope.compAlertData.isRatingMovementAllRatingAction = 'A';
				}
			} else if ($scope.compAlertData.isRatingMovementCheck == 'Y'
					&& $scope.compAlertData.isRatingMovAllRatingActionisCheck == 'N'
					&& $scope.compAlertData.isRatingMovOutlook == 'N') {
				$scope.compAlertData.isRatingMovementCheck = 'N';
				$scope.compAlertData.isRatingMovOutlook = 'N';
				$scope.compAlertData.isRatingMovAllRatingActionisCheck = 'N';
				$scope.compAlertData.isRatingMovementAllRatingAction = 'NA';
			}

		}

		$scope.doInnerRatingMovAllRatingActionisCheck = function() {

			if ($scope.compAlertData.isRatingMovementAllRatingAction == 'A'
					|| $scope.compAlertData.isRatingMovementAllRatingAction == 'N'
					|| $scope.compAlertData.isRatingMovementAllRatingAction == 'Y') {
				$scope.compAlertData.isRatingMovementCheck = 'Y';
				$scope.compAlertData.isRatingMovAllRatingActionisCheck = 'Y';
			}

		}

		$scope.updateFinancialFunction = function() {
			if ($scope.compAlertData.isUpdateFinancialCheck == 'N') {
				$scope.compAlertData.isUpdateFinancialKeyRatio = 'N';
				$scope.compAlertData.isUpdateFinancialFullFinancial = 'N';
			} else if ($scope.compAlertData.isUpdateFinancialCheck == 'Y') {

				$scope.compAlertData.isUpdateFinancialKeyRatio = 'Y';
				$scope.compAlertData.isUpdateFinancialFullFinancial = 'N';
			}
		}

		$scope.updateFinancialInnerFunction = function() {
			if ($scope.compAlertData.isUpdateFinancialFullFinancial == 'Y'
					|| $scope.compAlertData.isUpdateFinancialKeyRatio == 'Y') {
				$scope.compAlertData.isUpdateFinancialCheck = 'Y';
			} else if ($scope.compAlertData.isUpdateFinancialCheck == 'Y'
					&& $scope.compAlertData.isUpdateFinancialFullFinancial == 'N'
					&& $scope.compAlertData.isUpdateFinancialKeyRatio == 'N') {
				$scope.compAlertData.isUpdateFinancialCheck = 'N';
				$scope.compAlertData.isUpdateFinancialKeyRatio = 'N';
				$scope.compAlertData.isUpdateFinancialFullFinancial = 'N';
			}

		}
		$scope.capitalMarketMovementFunction = function() {

			if ($scope.compAlertData.isCapitalMarketMovementCheck == 'N') {
				$scope.compAlertData.isSharePriceCapitalMarketMovement = 'N';
				$scope.compAlertData.isBondYieldCapitalMarketMovement = 'N';
			} else if ($scope.compAlertData.isCapitalMarketMovementCheck == 'Y') {

				$scope.compAlertData.isSharePriceCapitalMarketMovement = 'Y';
				$scope.compAlertData.isBondYieldCapitalMarketMovement = 'N';
			}
		}

		$scope.capitalMarketMovementInnerFunction = function() {

			if ($scope.compAlertData.isSharePriceCapitalMarketMovement == 'Y'
					|| $scope.compAlertData.isBondYieldCapitalMarketMovement == 'Y') {
				$scope.compAlertData.isCapitalMarketMovementCheck = 'Y';
			} else if ($scope.compAlertData.isCapitalMarketMovementCheck == 'Y'
					&& $scope.compAlertData.isSharePriceCapitalMarketMovement == 'N'
					&& $scope.compAlertData.isBondYieldCapitalMarketMovement == 'N') {
				$scope.compAlertData.isCapitalMarketMovementCheck = 'N';
				$scope.compAlertData.isSharePriceCapitalMarketMovement = 'N';
				$scope.compAlertData.isBondYieldCapitalMarketMovement = 'N';
			}
		}

		$scope.quaterlyFinancialChangeFunction = function() {
			if ($scope.compAlertData.isQuaterlyFinancialCheck == 'N') {
				$scope.compAlertData.isSalesQuaterlyFinancialsMovement = 'N';
				$scope.compAlertData.isPatQuaterlyFinancialsMovement = 'N';
			} else if ($scope.compAlertData.isQuaterlyFinancialCheck == 'Y') {

				$scope.compAlertData.isSalesQuaterlyFinancialsMovement = 'Y';
				$scope.compAlertData.isPatQuaterlyFinancialsMovement = 'N';
			}

		}
		$scope.quaterlyFinancialChangeInnerFunction = function() {

			if ($scope.compAlertData.isSalesQuaterlyFinancialsMovement == 'Y'
					|| $scope.compAlertData.isPatQuaterlyFinancialsMovement == 'Y') {
				$scope.compAlertData.isQuaterlyFinancialCheck = 'Y';
			} else if ($scope.compAlertData.isQuaterlyFinancialCheck == 'Y'
					&& $scope.compAlertData.isSalesQuaterlyFinancialsMovement == 'N'
					&& $scope.compAlertData.isPatQuaterlyFinancialsMovement == 'N') {
				$scope.compAlertData.isQuaterlyFinancialCheck = 'N';
				$scope.compAlertData.isSalesQuaterlyFinancialsMovement = 'N';
				$scope.compAlertData.isPatQuaterlyFinancialsMovement = 'N';
			}

		}

		$scope.relatedCompaniesChangeFunction = function() {

			if ($scope.compAlertData.isRelatedCompaniesCheck == 'N') {
				$scope.compAlertData.isRealtedCompaniesRatingMovemnt = 'N';
			} else if ($scope.compAlertData.isRelatedCompaniesCheck == 'Y') {

				$scope.compAlertData.isRealtedCompaniesRatingMovemnt = 'Y';
			}

		}
		$scope.relatedCompaniesChangeInnerFunction = function() {

			if ($scope.compAlertData.isRealtedCompaniesRatingMovemnt == 'Y') {
				$scope.compAlertData.isRelatedCompaniesCheck = 'Y';
			} else if ($scope.compAlertData.isRelatedCompaniesCheck == 'Y'
					&& $scope.compAlertData.isRealtedCompaniesRatingMovemnt == 'N') {
				$scope.compAlertData.isRelatedCompaniesCheck = 'N';
				$scope.compAlertData.isRealtedCompaniesRatingMovemnt = 'N';
			}
		}

		$scope.saveCompanyAlertData = function() {
			if ($window
					.confirm("Are you sure you want to Set Alert for this Company ?")) {

				if ($scope.flagRatingMovementStatus) {
					$scope.compAlertData.isRatingMovementCheck = 'N';
					$scope.compAlertData.isRatingMovOutlook = 'N';
					$scope.compAlertData.isRatingMovAllRatingActionisCheck = 'N';
					$scope.compAlertData.isRatingMovementAllRatingAction = 'N';
				}

				if ($scope.flagAllAlerttStatus) {
					$scope.compAlertData.isUpdateFinancialCheck = 'N';
					$scope.compAlertData.isUpdateFinancialKeyRatio = 'N';
					$scope.compAlertData.isUpdateFinancialFullFinancial = 'N';
					$scope.compAlertData.isCapitalMarketMovementCheck = 'N';
					$scope.compAlertData.isSharePriceCapitalMarketMovement = 'N';
					$scope.compAlertData.isBondYieldCapitalMarketMovement = 'N';
					$scope.compAlertData.isQuaterlyFinancialCheck = 'N';
					$scope.compAlertData.isSalesQuaterlyFinancialsMovement = 'N';
					$scope.compAlertData.isPatQuaterlyFinancialsMovement = 'N';
					$scope.compAlertData.isRelatedCompaniesCheck = 'N';
					$scope.compAlertData.isRealtedCompaniesRatingMovemnt = 'N';
					// $scope.compAlertData.isCrrAvailable = 'N';
				}
				if ($scope.flagCRRAlerttStatus) {
					$scope.compAlertData.isCrrAvailable = 'N';
				}
				if(	$scope.flagSFAlerttStatus){
					$scope.compAlertData.isSfAvailable = 'N';
					}
				
				if ($scope.flagRatingMovementStatus != true
						|| $scope.flagAllAlerttStatus != true) {

					CompanyIndAlertService
							.setCompanyLevelAlert($scope.compAlertData)
							.then(
									function(result) {
										$timeout(
												function() {

													if (result.isSuccess == 'true') {
														$scope.issuccess = true;
														$scope.error = false;
														$scope.successMessages = result.message;
														if (controllerModule == 'companyProfile') {
															parentAccess.setStatus = true;
															parentAccess.alertAction = 'Remove Alert';
															parentAccess.companyAlertFlag = false;
														} else if (controllerModule == 'RatingDetailsController1') {

															parentAccess.setStatus = true;
														} else if (controllerModule == 'RatingListController'
																|| controllerModule == 'AdvanceSearchController'
																|| controllerModule == 'CustomizeDashboardController') {

															parentAccess.setStatus = true;
														}

													} else {
														$scope.error = true;
														$scope.issuccess = false;
														$scope.errorMessages = result.message;
													}

													$timeout(
															function() {
																$uibModalInstance
																		.dismiss('cancel');
															}, 1000);
												}, 1000);
									},
									function(response, status, headers, config) {
										$scope.error = true;
										$scope.errorMessage = "Error occured while setting Alert"
										$uibModalInstance.dismiss('cancel');
									});

				}

			} else {
				parentAccess.setStatus = false;
				$uibModalInstance.dismiss('cancel');
			}
		}

		$scope.defaultAlertData = function() {
			$scope.compAlertData = {
				name : 'Company Alert',
				companyCode : companyData.companyCode,
				industryId : companyData.industryId,
				portFolioId : companyData.portFolioId,
				isIndustryLevel : companyData.isIndustryLevel,
				isPortfolioLevel : companyData.isPortfolioLevel,
				isCompanyLevel : companyData.isCompanyLevel,

				isRatingList : 'N',
				isRatingMovementCheck : 'Y',
				isRatingMovOutlook : 'N',
				isRatingMovAllRatingActionisCheck : 'Y',
				isRatingMovementAllRatingAction : 'A',

				isUpdateFinancialCheck : 'Y',
				isUpdateFinancialKeyRatio : 'Y',
				isUpdateFinancialFullFinancial : 'N',
				isCapitalMarketMovementCheck : 'Y',
				isSharePriceCapitalMarketMovement : 'Y',
				isBondYieldCapitalMarketMovement : 'N',
				isQuaterlyFinancialCheck : 'Y',
				isSalesQuaterlyFinancialsMovement : 'Y',
				isPatQuaterlyFinancialsMovement : 'N',
				isRelatedCompaniesCheck : 'Y',
				isRealtedCompaniesRatingMovemnt : 'Y',

				isCrrAvailable : 'Y',
				isSfAvailable : 'Y'
			};

			if ($scope.flagRatingMovementStatus) {
				$scope.compAlertData.isRatingList = 'N';
				$scope.compAlertData.isRatingMovementCheck = 'N';
				$scope.compAlertData.isRatingMovOutlook = 'N';
				$scope.compAlertData.isRatingMovAllRatingActionisCheck = 'N';
				$scope.compAlertData.isRatingMovementAllRatingAction = 'NA';
			}

			if ($scope.flagAllAlerttStatus) {
				$scope.compAlertData.isUpdateFinancialCheck = 'N';
				$scope.compAlertData.isUpdateFinancialKeyRatio = 'N';
				$scope.compAlertData.isUpdateFinancialFullFinancial = 'N';
				$scope.compAlertData.isCapitalMarketMovementCheck = 'N';
				$scope.compAlertData.isSharePriceCapitalMarketMovement = 'N';
				$scope.compAlertData.isBondYieldCapitalMarketMovement = 'N';
				$scope.compAlertData.isQuaterlyFinancialCheck = 'N';
				$scope.compAlertData.isSalesQuaterlyFinancialsMovement = 'N';
				$scope.compAlertData.isPatQuaterlyFinancialsMovement = 'N';
				$scope.compAlertData.isRelatedCompaniesCheck = 'N';
				$scope.compAlertData.isRealtedCompaniesRatingMovemnt = 'N';
			}
			if ($scope.flagCRRAlerttStatus) {
				$scope.compAlertData.isCrrAvailable = 'N';
			}
			if(	$scope.flagSFAlerttStatus){
				console.log("in a ccc2");
			$scope.compAlertData.isSfAvailable = 'N';
			}
			
		}

		$scope.cancel = function() {
			$uibModalInstance.dismiss('cancel');
			/*
			 * $rootScope.cancelSetAlert=true; $scope.removeAlertsuccess=false;
			 */
		}

		$scope.dynamicClassChange = function(value) {
			if ('Y' == value) {
				return "fa fa-plus-circle pull-right block font-green-meadow";
			} else if ('N' == value) {
				return "fa fa-minus-circle pull-right block font-green-meadow";
			}

		}

		$scope.getCompanyAlertDetails();

		$scope.saveAllCompanyAlertData = function() {
			if ($window
					.confirm("Are you sure you want to Set Alert for All Companies ?")) {

				if ($scope.flagRatingMovementStatus) {
					$scope.compAlertData.isRatingMovementCheck = 'N';
					$scope.compAlertData.isRatingMovOutlook = 'N';
					$scope.compAlertData.isRatingMovAllRatingActionisCheck = 'N';
					$scope.compAlertData.isRatingMovementAllRatingAction = 'N';
				}

				if ($scope.flagAllAlerttStatus) {
					$scope.compAlertData.isUpdateFinancialCheck = 'N';
					$scope.compAlertData.isUpdateFinancialKeyRatio = 'N';
					$scope.compAlertData.isUpdateFinancialFullFinancial = 'N';
					$scope.compAlertData.isCapitalMarketMovementCheck = 'N';
					$scope.compAlertData.isSharePriceCapitalMarketMovement = 'N';
					$scope.compAlertData.isBondYieldCapitalMarketMovement = 'N';
					$scope.compAlertData.isQuaterlyFinancialCheck = 'N';
					$scope.compAlertData.isSalesQuaterlyFinancialsMovement = 'N';
					$scope.compAlertData.isPatQuaterlyFinancialsMovement = 'N';
					$scope.compAlertData.isRelatedCompaniesCheck = 'N';
					$scope.compAlertData.isRealtedCompaniesRatingMovemnt = 'N';
					// $scope.compAlertData.isCrrAvailable = 'N';
				}
				if ($scope.flagCRRAlerttStatus) {
					$scope.compAlertData.isCrrAvailable = 'N';
				}
				if ($scope.flagRatingMovementStatus != true
						|| $scope.flagAllAlerttStatus != true) {

					$scope.compAlertData.isInstrumentalType = companyData.isInstrumentalType;
					$scope.compAlertData.portfolioFilter = companyData.portfolioFilter;
					$scope.compAlertData.isRatingList = companyData.isRatingList;
					$scope.compAlertData.isBankerRated = companyData.isBankerRated;
					$scope.compAlertData.isAdvanceSearchLevel = companyData.isAdvanceSearchLevel;

					CompanyIndAlertService
							.setCompanyLevelAlert($scope.compAlertData)
							.then(
									function(result) {

										alert(result.message);

										if (result.isSuccess == 'true') {

											if (controllerModule == 'RatingDetailsController1') {
												if (companyData.ratingDetailType == 'stdPortfolioDetails') {
													parentAccess
															.getPortfolioListFilterData();
												} else if (companyData.ratingDetailType == 'userPortfolioDetails') {
													parentAccess
															.getUserPortfolioForSetAlertAllList($scope.compAlertData.portfolioFilter);
												} else if (companyData.ratingDetailType == 'instrumentalType') {
													parentAccess
															.getInstrumentDetailsFilterData();

												}

											} else if (controllerModule == 'RatingListController') {
												if (companyData.isInstrumentalType == 'CREDIT') {
													parentAccess
															.getCrisilCreditRatingsList();
												} else if (companyData.isInstrumentalType == 'SME') {
													parentAccess
															.smeFilterValidation();
												} else if (companyData.isInstrumentalType == 'NSIC') {
													parentAccess
															.nsicFilterValidation();
												} else if (companyData.isInstrumentalType == 'INSTRUMENTISIN') {
													parentAccess
															.getInstrumentsISIN();
												}else if (companyData.isInstrumentalType == 'SF') {
													parentAccess
													.sfValidation();
										}
											} else if (controllerModule == 'AdvanceSearchController') {
												if ($window
														.confirm("Are you sure you want to reload All Companies?")) {
													
													parentAccess.cacheReload = true;
													if (parentAccess.searchType === 'WIZARD') {
														parentAccess
																.seachWizardGnerate();
													} else if (parentAccess.searchType === 'CUSTOM'
															|| parentAccess.runflag) {
														parentAccess
																.searchComapny(true);
													} else if (parentAccess.searchType === 'COMPANY_TOOL') {
														parentAccess
																.searchCompanyTool('search');
													}
												}
											} else if (controllerModule == 'CustomizeDashboardController') {
												if ($window
														.confirm("Are you sure you want to reload All Companies?")) {
													if (companyData.isInstrumentalType === 'RATED') {
														parentAccess
																.filterValidationForBanker();

													}
												}

											}

										}

									},
									function(response, status, headers, config) {
										$scope.error = true;
										$scope.errorMessage = "Error occured while setting Alert"
										$uibModalInstance.dismiss('cancel');
									});

					$scope.issuccess = true;
					$scope.successMessages = "Alert has been set in process";
					$scope.error = false;
					$timeout(function() {
						$uibModalInstance.dismiss('cancel');
					}, 1000);

				}
			} else {
				parentAccess.setStatus = false;
				$uibModalInstance.dismiss('cancel');
			}
		}
	}
})();